import script from "./FaqQuestionBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./FaqQuestionBox.vue?vue&type=script&setup=true&lang=ts"

import "./FaqQuestionBox.vue?vue&type=style&index=0&id=06886650&lang=css"

const __exports__ = script;

export default __exports__